import { useCallback } from 'react'
import { HOME_PRODUCT_KEYS, SECONDARY_VIEW_KEYS } from '@/config/navigation/secondaryNav'
import PATHS from '@/routes/paths'

/**
 * Open the Schedules page.
 *
 * Clearing the selected thread is what makes the route stick: `displayThreadId`
 * falls back to the selection when the URL carries no thread, so leaving it set
 * would render the chat over this page — and the URL sync would then navigate
 * straight back to that thread.
 */
export function useSecondarySchedules({
  navigate,
  setSelectedThreadId,
  setHomeView,
  setHomeProduct,
}) {
  return useCallback(() => {
    setHomeProduct(HOME_PRODUCT_KEYS.CHAT)
    setHomeView(SECONDARY_VIEW_KEYS.HOME_MAIN)
    setSelectedThreadId(null)
    navigate(PATHS.SCHEDULES)
  }, [navigate, setHomeProduct, setHomeView, setSelectedThreadId])
}
